import { Languages } from '@/store/modules/job/types';

export interface LanguageOption {
  value: Languages;
  textLabel: string;
}

export const languageOptions: LanguageOption[] = [
  { value: Languages.ASE, textLabel: 'ASL' },
  { value: Languages.ARA, textLabel: 'Arabic' },
  { value: Languages.ZHO, textLabel: 'Chinese' },
  { value: Languages.FRA, textLabel: 'French' },
  { value: Languages.DEU, textLabel: 'German' },
  { value: Languages.ELL, textLabel: 'Greek' },
  { value: Languages.HEB, textLabel: 'Hebrew' },
  { value: Languages.HIN, textLabel: 'Hindi' },
  { value: Languages.ITA, textLabel: 'Italian' },
  { value: Languages.JPN, textLabel: 'Japanese' },
  { value: Languages.KOR, textLabel: 'Korean' },
  { value: Languages.POR, textLabel: 'Portuguese' },
  { value: Languages.RUS, textLabel: 'Russian' },
  { value: Languages.SPA, textLabel: 'Spanish' },
];
